// extracted by mini-css-extract-plugin
export default {"White":"#FFFFFF","basketBarHeight":"4rem","actionBarHeight":"3.5rem","bootstrap":"G694749 G631acc","pageContainer":"G29fbf9","pullUp":"G2fb1fb","withBottomBar":"Gddbaa4"};